// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryList_wrapper__bLB1O"};